// startup
// Load entry module and return exports
// This entry module is referenced by other modules so it can't be inlined
__webpack_require__("./node_modules/slick-carousel/slick/slick.js");
__webpack_require__("./node_modules/@fancyapps/fancybox/dist/jquery.fancybox.js");
__webpack_require__("./node_modules/@uvarov.frontend/vanilla-calendar/build/vanilla-calendar.min.js");
var __webpack_exports__ = __webpack_require__("./resources/js/scripts.js");
